<template>
    <div class="app-container">
        <el-form :inline="true" :model="filters">
            <el-form-item>
                <el-input size="small" v-model="filters.search" placeholder="关键字"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" v-on:click="queryAll">查询</el-button>
                <el-button size="small" type="success" @click="handleCreate">添加</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="mini" stripe border :data="tableData" highlight-current-row expand-on-click-node="false">
            <el-table-column prop="Name" label="跑团名称" width="150">
            </el-table-column>
            <el-table-column prop="GroupMembers" label="包含成员" min-width="200">
                <template slot-scope="scope">
                    <memberList v-if="scope.row.GroupMembers" :groupMembers="scope.row.GroupMembers.Items" /> 
                </template>
            </el-table-column>
            <el-table-column prop="Desc" label="备注" min-width="80">
            </el-table-column>
            <el-table-column prop="IsEnabled" label="是否生效" width="100">
                 <template slot-scope="scope">
                    <el-tag v-if="scope.row.IsEnabled" type="success">生效</el-tag>
                    <el-tag v-else type="danger">停止</el-tag>
                </template>
            </el-table-column>
            <el-table-column sortable prop="InsertTime" label="创建时间" width="130">
                <template slot-scope="scope">
                    {{ format.dateTimeFormat(scope.row.InsertTime) }}
                </template>
            </el-table-column>
            <el-table-column sortable prop="Creator.Name" label="创建人" width="100">
            </el-table-column>
            <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="handleMembers(scope.row)">成员</el-button>
                    <el-button type="text" size="small" @click="handleUpdate(scope.row)">修改</el-button>
                    <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="pageSizesList" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total" :current-page.sync="pageIndex"></el-pagination>
        </div>
        <groupEditor ref="groupEditor" @update="queryAll" />
        <groupMember ref="groupMember" @update="queryAll" />
    </div>
</template>
<script>
import { GetPageList, DelGroup } from "@/api/traning/runGroup";
import groupEditor from "./components/groupEditor.vue";
import memberList from "./components/memberList.vue";
import groupMember from "./components/groupMember.vue";
export default {
    components: {
        groupEditor,
        memberList,
        groupMember,
    },
    data() {
        return {
            filters: {
                search: ""
            },
            tableData: [],
            total: 0,
            pageIndex: 1,
            pageSize: 10,
            pageSizesList: [10, 15, 20, 30, 50],
        };
    },
    methods: {
        queryAll() {
            let para = {
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                search: this.filters.search,
            };
            GetPageList(para).then((response) => {
                if (response) {
                    this.tableData = response.Items;
                    this.total = response.Total || response.Items.length;
                }
            });
        },
        handleCreate() {
            this.$nextTick(() => {
                this.$refs["groupEditor"].handleCreate();
            });
        },
        handleUpdate(row) {
            this.$nextTick(() => {
                this.$refs["groupEditor"].handleUpdate(row);
            });
        },
        handleMembers(row) {
            this.$nextTick(() => {
                this.$refs["groupMember"].show(row);
            });
        },
        //删除
        handleDelete: function (row) {
            this.$confirm("确认删除该跑团吗?", "提示", {
                type: "warning",
            }).then(() => {
                let para = { key: row.Key };
                DelGroup(para).then((response) => {
                    if (response) {
                        this.msg.successMsg("操作成功");
                        this.queryAll();
                    }
                });
            });
        },
        handleSizeChange(val) {
            var pageSize = `${val}`;
            this.pageIndex = 1;
            this.pageSize = parseInt(pageSize);
            this.$nextTick(() => this.queryAll());
        },

        handleCurrentChange(val) {
            this.pageIndex = `${val}`;
            this.queryAll();
        },
    },
    mounted() {
        this.queryAll();
    },
};
</script>